import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgZorroAntdModule } from 'ng-zorro-antd';
import { IndexBlockComponent } from './index-block/index-block.component';




@NgModule({
  declarations: [IndexBlockComponent],
  imports: [
    CommonModule,
    NgZorroAntdModule
  ],
  exports: [IndexBlockComponent]
})
export class BlockModule { }
